import logotyp from '../assets/logotyp.svg';
import { Button, chakra, Skeleton } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';

export function BrandLogo(props: { compact?: boolean }) {
    const [logoLoaded, setLogoLoaded] = useState(false);

    return (
        <NavLink to="/?noRedirectToPanel" replace>
            <Button variant="plain" ml={-4} pr={props.compact ? 0 : undefined}>
                {!logoLoaded && <Skeleton variant='shine' height="40px" width="120px" borderRadius="md" />}
                <chakra.img
                    src={logotyp}
                    height="40px"
                    onLoad={() => setLogoLoaded(true)}
                    onError={() => setLogoLoaded(true)}
                    style={{ display: logoLoaded ? 'block' : 'none' }}
                />
            </Button>
        </NavLink>
    );
}
